module.exports = __webpack_public_path__ + "assets/9dea8f1916e3a8e6dc1369dedef7d7aa.mp4";